import { render, staticRenderFns } from "./MainTiktok.vue?vue&type=template&id=5fbe79dd&"
import script from "./MainTiktok.vue?vue&type=script&lang=js&"
export * from "./MainTiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports